import WizardController from '../wizard_controller'

export default class extends WizardController {

  static targets = [
    'conditionDetails',
    'familyMemberDetails',
    'noneInverse',
    'otherConditionsDetails',
    'otherConditionsDetailsInput'
  ]

  static values = {}

  static classes = []

  initialize() {}

  connect() {}

  // ==== Controllers

  // ==== Actions

  toggleNoneInverse(event) {
    this.toggleNoneInverseSelection({
      input:  event.currentTarget,
      target: this.noneInverseTarget
    })
  }

  toggleConditionDetails({ currentTarget, params: { condition } }) {
    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: this.conditionDetailsTargets.find((target) => (
        target.dataset.condition === condition
      ))
    })
  }

  toggleFamilyMemberDetails({ currentTarget, params: { condition, familyMember } }) {
    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: this.familyMemberDetailsTargets.find((target) => (
        target.dataset.condition === condition &&
          target.dataset.familyMember === familyMember
      ))
    })
  }

  toggleOtherConditionsDetails(event) {
    this.toggleCheckboxMoreDetails({
      input:  event.currentTarget,
      target: this.otherConditionsDetailsTarget
    })
  }

  addOtherConditionsDetailsItem() {
    this.addNestedForm({
      list:      this.otherConditionsDetailsInputTargets,
      inputType: 'textarea',
      wrapper:   this.otherConditionsDetailsTarget
    })
  }

  removeOtherConditionsDetailsItem(event) {
    this.removeNestedForm({
      button:    event.currentTarget,
      wrapper:   this.otherConditionsDetailsTarget,
      list:      this.otherConditionsDetailsInputTargets,
      inputType: 'textarea'
    })
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
